import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

/* comp imports */
import Home from "./pages/Home";
import { getCurrentUrl } from "./data/common";

const BUCKET_URL =
  process.env.REACT_APP_ENVIRONMENT === "development"
    ? process.env.REACT_APP_BUCKET_URL
    : process.env.REACT_APP_BUCKET_URL_PROD;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function App() {
  const query = useQuery();
  const storyId = query.get("story_id");
  const modelId = query.get("modelId");

  const [ogData, setOgData] = useState({
    siteName: "Experience Engine",
    type: "website",
    title: "",
    description: "",
    image: "",
    imageAlt: "",
    twitterCard: "summary_large_image",
    twitterSite: "@website",
  });

  useEffect(() => {
    if (modelId) {
      const fetchUrl = `/datas/${modelId}.json`;
      fetch(fetchUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          const json = data.response;
          const linkPreview =
            json.categories?.filter(
              (_category) => Number(_category.category_id) === Number(storyId)
            )[0]?.link_preview || {};
          setOgData((prev) => ({
            ...prev,
            ...{
              title: linkPreview?.title || prev.title,
              description: linkPreview?.description || prev.description,
              image: `${BUCKET_URL}${linkPreview?.image}` || prev.image,
              imageAlt: linkPreview?.image_alt || prev.imageAlt,
            },
          }));
        })
        .catch((error) =>
          console.error(
            "There has been a problem with your fetch operation:",
            error
          )
        );
    }
  }, [modelId, storyId]);

  return (
    <HelmetProvider>
      <Helmet>
        {storyId ? (
          <>
            <meta
              property="og:site_name"
              content={ogData.siteName}
              data-rh="true"
            />
            <meta property="og:url" content={getCurrentUrl()} />
            <meta property="og:title" content={ogData.title} data-rh="true" />
            <meta property="og:type" content={ogData.type} data-rh="true" />
            <meta
              property="og:description"
              content={ogData.description}
              data-rh="true"
            />
            <meta property="og:image" content={ogData.image} data-rh="true" />
            <meta
              property="og:image:alt"
              content={ogData.imageAlt}
              data-rh="true"
            />

            <meta
              name="twitter:card"
              content={ogData.twitterCard}
              data-rh="true"
            />
            <meta
              name="twitter:site"
              content={ogData.twitterSite}
              data-rh="true"
            />
            <meta name="twitter:title" content={ogData.title} data-rh="true" />
            <meta
              name="twitter:description"
              content={ogData.description}
              data-rh="true"
            />
            <meta name="twitter:image" content={ogData.image} data-rh="true" />
          </>
        ) : null}
      </Helmet>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </HelmetProvider>
  );
}

export default App;
